import wNumb from "wnumb";
import noUiSlider from "nouislider";

class RangeSliderController {
  constructor() {
    this.slider = null;
  }

  init() {
    this.slider = document.getElementById("slider-range");

    if (this.slider && !this.slider.noUiSlider) {
      this.setupSlider();
    }
  }

  setupSlider() {
    let rangeSlider = this.slider;
    let sliderRangeValue1 = document.getElementById("slider-range-value1");
    let sliderRangeValue2 = document.getElementById("slider-range-value2");

    if (!sliderRangeValue1 || !sliderRangeValue2) {
      console.error("Range slider input fields are missing!");
      return;
    }

    const thousandSeparator = rangeSlider.getAttribute("data-thousand") || ".";
    const currencySuffix = rangeSlider.getAttribute("data-currency") || "€";

    const moneyFormat = wNumb({
      decimals: 0,
      thousand: thousandSeparator,
      suffix: " " + currencySuffix,
    });

    const minValue = Number(sliderRangeValue1.getAttribute("initial-value")) || 0;
    const maxValue = Number(sliderRangeValue2.getAttribute("initial-value")) || 100;

    const step = Math.max((maxValue - minValue) / 100, 1);

    const startingValue1 = Number(document.querySelector("input[name='min-value']").value) || minValue;
    const startingValue2 = Number(document.querySelector("input[name='max-value']").value) || maxValue;

    noUiSlider.create(rangeSlider, {
      start: [startingValue1, startingValue2],
      step: step,
      range: {
        min: [minValue],
        max: [maxValue],
      },
      format: moneyFormat,
      connect: true,
    });

    rangeSlider.noUiSlider.on("update", function (values, handle) {
      sliderRangeValue1.value = moneyFormat.from(values[0]);
      sliderRangeValue2.value = moneyFormat.from(values[1]);

      document.getElementsByName("min-value").forEach((element) => {
        const oldValue = Number(element.value);
        const newValue = moneyFormat.from(values[0]);
        element.value = newValue;

        if (newValue !== oldValue) {
          element.dispatchEvent(new Event("change"));
        }
      });

      document.getElementsByName("max-value").forEach((element) => {
        const oldValue = Number(element.value);
        const newValue = moneyFormat.from(values[1]);
        element.value = newValue;

        if (newValue !== oldValue) {
          element.dispatchEvent(new Event("change"));
        }
      });
    });

    sliderRangeValue1.addEventListener("change", (event) => {
      event.preventDefault();

      let value = parseFloat(sliderRangeValue1.value);
      value = isNaN(value) ? minValue : Math.max(minValue, Math.min(value, maxValue));
      rangeSlider.noUiSlider.set([value, null]);
    });

    sliderRangeValue2.addEventListener("change", (event) => {
      event.preventDefault();

      let value = parseFloat(sliderRangeValue2.value);
      value = isNaN(value) ? maxValue : Math.max(minValue, Math.min(value, maxValue));
      rangeSlider.noUiSlider.set([null, value]);
    });

    [sliderRangeValue1, sliderRangeValue2].forEach((input) => {
      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          input.dispatchEvent(new Event("change"));
        }
      });
    });
  }
}

export let rangeSliderController = new RangeSliderController();
document.addEventListener("DOMContentLoaded", () => rangeSliderController.init());
